import { useSearchParams } from "react-router-dom";

import { getConfig } from "config/config";
import { SHOW_ALL_PARAM, USSLG } from "config/constants";
import { useUser } from "hooks/user/useUser";

/**
 * Whether to hide pages that list every account's data (detector list, global review queue) from the current
 * user, so admins in usslg don't see customer images by accident. `?show_all=true` overrides it.
 */
export function useIsAdminBrowsingBlocked(): boolean {
  const user = useUser();
  const [searchParams] = useSearchParams();

  return (
    getConfig().REACT_APP_STAGE === USSLG && !!user?.is_superuser && searchParams.get(SHOW_ALL_PARAM) !== "true"
  );
}
